export function syncTabsBackdrop() {
    const components = document.querySelectorAll('.tabs-component');
    if (!components.length) return;

    components.forEach((component) => {
        const inner = component.querySelector('.tabs-component__inner');
        const container = component.querySelector('.tabs-component__container');
        if (!inner || !container) return;

        let ro = null;

        const measure = () => {
            if (window.innerWidth > 768) {
                component.style.removeProperty('--tabs-backdrop-height');
                return;
            }

            const activeItem = container.querySelector('.accordion__item--active');
            const media = activeItem?.querySelector('.tabs-component__video');
            if (!media) return;

            const mediaRect = media.getBoundingClientRect();
            const componentRect = component.getBoundingClientRect();

            const fullHeight = mediaRect.bottom - componentRect.top;
            const OFFSET_RATIO = 0.83;
            const scaledOffset = mediaRect.height * OFFSET_RATIO;

            const height = Math.round(fullHeight - scaledOffset);

            if (height > 0) {
                component.style.setProperty('--tabs-backdrop-height', `${height}px`);
                component.style.setProperty('--tabs-backdrop-before-height', `${Math.round(height * 0.8)}px`);
            }
        };

        const observeActiveMedia = () => {
            ro?.disconnect();

            const activeItem = container.querySelector('.accordion__item--active');
            const media = activeItem?.querySelector('.tabs-component__video');
            if (!media) return;

            ro = new ResizeObserver(measure);
            ro.observe(media);
            measure();
        };

        observeActiveMedia();

        window.addEventListener('resize', measure);

        const mo = new MutationObserver(observeActiveMedia);
        mo.observe(container, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true,
        });
    });

}